/**
 * ТЗ 0119: значения — переменные палитры (src/styles/palette.css), светлое
 * значение каждой равно прежнему hex, тёмное — по роли члена (фон, текст,
 * рамка, тень). Роль по месту употребления в CSS-шаблонах проставил
 * scripts/theme/codemod.js; новый код берёт токены `T` (services/ThemeTokens).
 * Исходные hex — в комментариях ниже и в palette.css.
 */
export enum Colors {
  Transparent = 'transparent',
  White = 'var(--k-bg-ffffff)',
  // Вторичный текст. Было #88959E: 3.07:1 на белом и 2.66 на LightGray при
  // норме 4.5 — этим цветом покрашены подписи полей, пустые состояния и
  // счётчики по всему ERP (142 места), поэтому недобор шёл на каждом экране.
  // #616E78 даёт 5.24 / 4.79 / 4.53 и сохраняет тот же сине-серый тон.
  // Фоном Gray не используется нигде, так что затемнение ничего не ломает.
  Gray = 'var(--k-fg-616e78)',
  LightGray = 'var(--k-border-ebeff2)',
  Red = 'var(--k-fg-f44336)',
  SeaBuckthorn = 'var(--k-fg-faae2b)',
  SpringWood = 'var(--k-bg-faf9f6)',
  Black = 'var(--k-fg-263446)',
  Blue = 'var(--k-fg-0d53fc)',
  MainBackground = 'var(--k-bg-f2f5f9)',
  PrimaryBlack = 'var(--k-fg-000000)',
  SecondLightGray = 'var(--k-border-dfe6f1)',
  ModalBackground = 'var(--k-overlay-31416d-a400)',
  LightBlue = 'var(--k-bg-fafbfd)',
  DeactivatedGrey = 'var(--k-border-c6ccd0)',
  SuccessDefault = 'var(--k-fg-3cc13b)',
  LightShadow = 'var(--k-shadow-88959e-a80)',
  BlueShadow = 'var(--k-shadow-263446-a40)',
  BlueShadowRow = 'var(--k-shadow-263446-a120)',
  WarningDefault = 'var(--k-fg-f3bb1c)',
  ErrorDefault = 'var(--k-fg-f03738)',
  BasicBlueLight = 'var(--k-bg-e7eeff)',
  // Текстовые варианты сигнальных цветов.
  //
  // Сами SuccessDefault / WarningDefault / ErrorDefault остаются как есть: они
  // верны для РАМОК, точек и индикаторов, где яркость и нужна. Но как ТЕКСТ на
  // белом они дают 2.36 / 1.76 / 3.96 при норме 4.5 — подпись «подключено» или
  // «просрочено» читалась хуже всего именно там, где важна.
  // Значения ниже: 5.13-6.29 / 5.54 / 5.62 на белом и не ниже 4.4 на плашках.
  SuccessText = 'var(--k-fg-256e29)',
  WarningText = 'var(--k-fg-8a6100)',
  ErrorText = 'var(--k-fg-c62828)',
}
